<template>
  <div class="container">

    <!-- HEADER -->
    <div class="header row p-0 m-0">
      <div class="col-12 col-lg-6 p-0 m-0">
        <img :src="`${publicPath}img/Grupo de desplazamiento 231.jpg`" data-aos="fade-left" data-aos-duration="1000" class="img-responsive">
      </div>
      <div class="col-12 col-lg-6 text-start p-5 pb-0">
        <h1 class="text-blue mt-3">{{ $t('organizacion.title') }}</h1>
        <p>{{ $t('organizacion.protocolos') }}</p>
      </div>
    </div>
    <!-- end HEADER -->

    <section class="p-0 p-lg-5 mx-0 mx-lg-5">
      <div class="row">
        <div class="col-12 col-lg-8 m-auto">
        <h2 class="mb-3 px-5">{{ $t('organizacion.buen') }}</h2>
        </div>
      </div>

      <div class="row align-content-center">
        <div class="col-12 col-lg-6  text-center text-lg-start align-self-center pe-3 pe-lg-5">
          <p class="text-black">{{ $t('organizacion.cuenta') }}</p>
        </div>
        <div class="col-12 col-lg-6">
          <div class="container border border-light p-3 m-0">
            <img :src="`${publicPath}img/politicaPrevencion${locale}.gif`" data-aos="fade-left" data-aos-duration="1000" class="img-responsive">
            <div class="col-12 col-lg-4 m-auto">
              <p class="myriadPro m-0 p-0 mt-3">{{ $t('organizacion.sistema') }}</p>
              <p class="textSmall m-0 p-0">{{ $t('organizacion.certificado') }}</p>
            </div>
          </div>
          <hr class="filigrana mb-0">
        </div>
      </div>

      <div class="row my-3">
        <h2 class="my-3">{{ $t('organizacion.comunicacion') }}</h2>
        <h6 class="text-black mb-5"><strong>{{ $t('organizacion.desarrollo') }}</strong></h6>
        <div class="col-12 col-lg-4 px-5 mb-5 mb-lg-0 border-end border-light">
          <img :src="`${publicPath}img/Grupo 2084.png`" data-aos="fade-down" data-aos-duration="1000" data-aos-id="start-counter-informe" class="img-responsive mb-3">
          <p><strong>{{ $t('organizacion.portal_corporativo') }}</strong></p>
          <h2 class="pb-0 mb-0">
            <AnimatedNumber
                ref='counter_paginas'
                :startAmount='0'
                :endAmount='3110616'
                :duration='3'
                prefix=''
                suffix=''
                :separator=separator
                :decimalSeparator=decimal_separator
                :decimals='0'
                :autoinit='true'
                @finished='counterFinished'
            />
            </h2>
          <p class="textSmall text-black">{{ $t('organizacion.paginas_visitadas') }}</p>
          <h2 class="pb-0 mb-0"><AnimatedNumber
              ref='counter_noticias'
              :startAmount='0'
              :endAmount='71'
              :duration='3'
              prefix=''
              suffix=''
              :separator=separator
              :decimalSeparator=decimal_separator
              :decimals='0'
              :autoinit='true'
              @finished='counterFinished'
          /></h2>
          <p class="textSmall text-black">{{ $t('organizacion.noticias_publicadas') }}</p>
          <p><strong>{{ $t('organizacion.redes') }}</strong></p>
          <h2 class="pb-0 mb-0">
            <AnimatedNumber
                ref='counter_seguidores'
                :startAmount='0'
                :endAmount='13821'
                :duration='3'
                prefix=''
                suffix=''
                :separator=separator
                :decimalSeparator=decimal_separator
                :decimals='0'
                :autoinit='true'
                @finished='counterFinished'
            /></h2>
          <p class="textSmall text-black">{{ $t('organizacion.seguidores') }}</p>
        </div>
        <div class="col-12 col-lg-4 px-5 mb-5 mb-lg-0 border-end border-light">
          <img :src="`${publicPath}img/Grupo 2113.png`" data-aos="fade-down" data-aos-delay="100" data-aos-duration="1000"  data-aos-id="start-counter-cuidado" clas="img-responsive mb-3">
          <p><strong>{{ $t('organizacion.comunicacion_interna') }}</strong></p>
          <h2 class="pb-0 mb-0">
            <AnimatedNumber
                ref='counter_comunicados'
                :startAmount='0'
                :endAmount='60'
                :duration='3'
                prefix=''
                suffix=''
                :separator=separator
                :decimalSeparator=decimal_separator
                :decimals='0'
                :autoinit='true'
                @finished='counterFinished'
            /></h2>
          <p class="textSmall text-black">{{ $t('organizacion.internos') }}</p>
          <p><strong>Portal Universal</strong></p>
          <h2 class="pb-0 mb-0"><AnimatedNumber
              ref='counter_publicadas'
              :startAmount='0'
              :endAmount='71'
              :duration='3'
              prefix=''
              suffix=''
              :separator=separator
              :decimalSeparator=decimal_separator
              :decimals='0'
              :autoinit='true'
              @finished='counterFinished'
          /></h2>
          <p class="textSmall text-black">{{ $t('organizacion.noticias_publicadas') }}</p>
          <h2 class="pb-0 mb-0">
            <AnimatedNumber
                ref='counter_unicas'
                :startAmount='0'
                :endAmount='29878'
                :duration='3'
                prefix=''
                suffix=''
                :separator=separator
                :decimalSeparator=decimal_separator
                :decimals='0'
                :autoinit='true'
                @finished='counterFinished'
            /></h2>
          <p class="textSmall text-black">{{ $t('organizacion.paginas_unicas') }}</p>
          <h2 class="pb-0 mb-0">
            <AnimatedNumber
                ref='counter_suscriptoras'
                :startAmount='0'
                :endAmount='403'
                :duration='3'
                prefix=''
                suffix=''
                :separator=separator
                :decimalSeparator=decimal_separator
                :decimals='0'
                :autoinit='true'
                @finished='counterFinished'
            />
            </h2>
          <p class="textSmall text-black">{{ $t('organizacion.suscriptoras') }}</p>
        </div>
        <div class="col-12 col-lg-4 px-5 mb-5 mb-lg-0">
          <img :src="`${publicPath}img/Grupo 2116.png`" data-aos="fade-down" data-aos-delay="200" data-aos-duration="1000" data-aos-id="start-counter-equipo" class="img-responsive mb-3">
          <p><strong>{{ $t('organizacion.externa') }}</strong></p>
          <h2 class="pb-0 mb-0">
            <AnimatedNumber
                ref='counter_envios'
                :startAmount='0'
                :endAmount='632'
                :duration='3'
                prefix=''
                suffix=''
                :separator=separator
                :decimalSeparator=decimal_separator
                :decimals='0'
                :autoinit='true'
                @finished='counterFinished'
            />
            </h2>
          <p class="textSmall text-black">{{ $t('organizacion.envios') }}</p>
          <h2 class="pb-0 mb-0">
            <AnimatedNumber
                ref='counter_impactos'
                :startAmount='0'
                :endAmount='198418'
                :duration='3'
                prefix=''
                suffix=''
                :separator=separator
                :decimalSeparator=decimal_separator
                :decimals='0'
                :autoinit='true'
                @finished='counterFinished'
            /></h2>
          <p class="textSmall text-black">{{ $t('organizacion.impactos') }}</p>
          <h2 class="pb-0 mb-0">
            <AnimatedNumber
                ref='counter_empresas'
                :startAmount='0'
                :endAmount='81'
                :duration='3'
                prefix=''
                suffix=''
                :separator=separator
                :decimalSeparator=decimal_separator
                :decimals='0'
                :autoinit='true'
                @finished='counterFinished'
            /></h2>
          <p class="textSmall text-black">{{ $t('organizacion.envios_empresa') }}</p>
          <h2 class="pb-0 mb-0"><AnimatedNumber
              ref='counter_impactos_2'
              :startAmount='0'
              :endAmount='85000'
              :duration='3'
              prefix=''
              suffix=''
              :separator=separator
              :decimalSeparator=decimal_separator
              :decimals='0'
              :autoinit='true'
              @finished='counterFinished'
          /></h2>
          <p class="textSmall text-black">{{ $t('organizacion.impactos') }}</p>
        </div>
      </div>

    </section>

    <section class="p-0 px-lg-5 py-lg-0 mx-0 mx-lg-5">

      <div class="row">
        <div class="col-12 col-lg-6 text-center text-lg-start pe-3 pe-lg-5">
          <h6><strong>{{ $t('organizacion.portal_universal') }}</strong></h6>
          <p class="text-black mt-4 me-0 me-lg-5">{{ $t('organizacion.mutua_lanzo') }}</p>
        </div>
        <div class="col-12 col-lg-6">
          <img :src="`${publicPath}img/Grupo de desplazamiento 36.jpg`" data-aos="fade-down" data-aos-delay="100" data-aos-duration="1000" class="img-responsive border border-light">
        </div>
      </div>

    </section>

    <section class="p-0 mx-0 mt-5 mx-lg-5">
      <div class="col-12 col-lg-10 g-0 p-0 m-auto px-0 px-lg-5">
        <h2>{{ $t('organizacion.equipo') }}</h2>
        <h6 class="text-black my-3"><strong>{{ $t('organizacion.cierre') }}</strong></h6>
        <div class="container border border-light p-3 m-0">
          <div class="row align-items-start">
            <div class="col-12 col-lg pt-5">
              <img :src="`${publicPath}img/icoF1A.png`" data-aos="fade" data-aos-delay="100" data-aos-duration="1000" data-aos-id="start-counter-pacientes" class="img-responsive">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_mujeres'
                  :startAmount='0'
                  :endAmount='66.75'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='2'
                  :autoinit='true'
                  @finished='counterFinished'
              />%</h2>
              <p class="textSmall text-black">{{ $t('literals.mujeres') }}</p>
            </div>
            <div class="col-4 col-lg-1 px-0 pt-4 mx-lg-0 m-auto">
              <hr>
            </div>
            <div class="col-12 col-lg pt-2">
              <img :src="`${publicPath}img/icoF1B.png`" data-aos="fade" data-aos-delay="100" data-aos-duration="1000" class="img-responsive">
              <h2 class="p-0 m-0">
                <AnimatedNumber
                    ref='counter_trabajadoras'
                    :startAmount='0'
                    :endAmount='1910'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                />
                </h2>
              <p class="textSmall text-black">{{ $t('organizacion.trabajadoras') }}</p>
            </div>
            <div class="col-4 col-lg-1 px-0 pt-4 mx-lg-0 m-auto">
              <hr>
            </div>
            <div class="col-12 col-lg pt-5">
              <img :src="`${publicPath}img/icoF1C.png`" data-aos="fade" data-aos-delay="100" data-aos-duration="1000" class="img-responsive">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_hombres'
                  :startAmount='0'
                  :endAmount='33.25'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='2'
                  :autoinit='true'
                  @finished='counterFinished'
              />%</h2>
              <p class="textSmall text-black">{{ $t('literals.hombres') }}</p>
            </div>
          </div>
          <hr class="my-5">
          <div class="row align-items-start">
            <div class="col-12 col-lg">
              <img :src="`${publicPath}img/icoF2A.png`" data-aos="fade" data-aos-delay="100" data-aos-duration="1000" data-aos-id="start-counter-inversiones" class="img-responsive">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_anos'
                  :startAmount='0'
                  :endAmount='47.02'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='2'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
              <p class="textSmall text-black">{{ $t('organizacion.anos_promedio') }}</p>
            </div>
            <div class="col-4 col-lg-1 px-0 pt-4 mx-lg-0 m-auto">
            </div>
            <div class="col-12 col-lg">
              <img :src="`${publicPath}img/icoF2B.png`" data-aos="fade" data-aos-delay="100" data-aos-duration="1000" class="img-responsive">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_antig'
                  :startAmount='0'
                  :endAmount='15.04'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='2'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
              <p class="textSmall text-black">{{ $t('organizacion.anos_antiguedad') }}</p>
            </div>
            <div class="col-4 col-lg-1 px-0 pt-4 mx-lg-0 m-auto">
            </div>
            <div class="col-12 col-lg">
              <img :src="`${publicPath}img/icoF2C.png`" data-aos="fade" data-aos-delay="100" data-aos-duration="1000" class="img-responsive">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_superior'
                  :startAmount='0'
                  :endAmount='82.04'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='2'
                  :autoinit='true'
                  @finished='counterFinished'
              />%</h2>
              <p class="textSmall text-black">{{ $t('organizacion.profesionales') }}</p>
            </div>
          </div>
          <div class="row align-items-start mt-5">
            <div class="col-12 col-lg-3">
              <img :src="`${publicPath}img/icoF3A.png`" data-aos="fade" data-aos-delay="100" data-aos-duration="1000" data-aos-id="start-counter-nacionalidades"  class="img-responsive">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_nacionalidades'
                  :startAmount='0'
                  :endAmount='27'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
              <p class="textSmall text-black">{{ $t('organizacion.nacionalidades') }}</p>
            </div>
            <div class="col-12 col-lg-3">
              <img :src="`${publicPath}img/icoF3B.png`" data-aos="fade" data-aos-delay="100" data-aos-duration="1000" class="img-responsive">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_discapacidad'
                  :startAmount='0'
                  :endAmount='38'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
              <p class="textSmall text-black">{{ $t('organizacion.discapacidad') }}</p>
            </div>
            <div class="col-12 col-lg-3">
              <img :src="`${publicPath}img/icoF3C.png`" data-aos="fade" data-aos-delay="100" data-aos-duration="1000" class="img-responsive">
              <h2 class="p-0 m-0">
                <AnimatedNumber
                    ref='counter_indefinidos'
                    :startAmount='0'
                    :endAmount='97.23'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='2'
                    :autoinit='true'
                    @finished='counterFinished'
                />%</h2>
              <p class="textSmall text-black">{{ $t('organizacion.indefinidos') }}</p>
            </div>
            <div class="col-12 col-lg-3">
              <img :src="`${publicPath}img/icoF3D.png`" data-aos="fade" data-aos-delay="100" data-aos-duration="1000" class="img-responsive">
              <h2 class="p-0 m-0"><AnimatedNumber
                  ref='counter_completo'
                  :startAmount='0'
                  :endAmount='80.16'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='2'
                  :autoinit='true'
                  @finished='counterFinished'
              />%</h2>
              <p class="textSmall text-black">{{ $t('organizacion.completo') }}</p>
            </div>
          </div>
        </div>
        <hr class="filigrana">
        <h2>{{ $t('organizacion.entorno_laboral') }}</h2>
        <h6 class="text-black my-3"><strong>{{ $t('organizacion.mutua_medidas') }}</strong></h6>

      </div>
    </section>


    <section class="p-0 p-lg-5 mx-0">
      <div class="row g-0 p-0 m-0">
        <div class="col-12 col-lg-6 px-0 px-lg-5 text-start">
          <img :src="`${publicPath}img/Grupo de desplazamiento 37.jpg`" data-aos="fade" data-aos-delay="100" data-aos-duration="1000" class="img-responsive">
          <h3 class="my-3">{{ $t('organizacion.conciliacion') }}</h3>
          <p class="text-black">{{ $t('organizacion.canal_unico') }}</p>
        </div>
        <div class="col-12 col-lg-6 px-0 px-lg-5 text-start">
          <img :src="`${publicPath}img/Grupo de desplazamiento 38.jpg`" data-aos="fade" data-aos-delay="100" data-aos-duration="1000" class="img-responsive">
          <h3 class="my-3">{{ $t('organizacion.diversidad') }}</h3>
          <p class="text-black">{{ $t('organizacion.diversidad_2021') }}</p>
        </div>
      </div>
    </section>

    <section class="p-0 mx-0 mx-lg-5">
      <div class="col-10 g-0 p-0 m-auto px-0 px-lg-5">
        <h2>{{ $t('organizacion.formacion') }}</h2>
        <h6 class="text-black my-3"><strong>{{ $t('organizacion.actividad_uni') }}</strong></h6>
      </div>
    </section>
    <section class="p-0 p-lg-5 mx-0">
      <div class="container">
        <div class="row border border-light justify-content-center g-0 p-0 m-0" data-aos="fade-in" data-aos-delay="200" data-aos-duration="1000" data-aos-id="start-counter-edu">
          <div class="col-12 col-lg p-3">
            <h2><AnimatedNumber
                ref='counter_cursos'
                :startAmount='0'
                :endAmount='578'
                :duration='3'
                prefix=''
                suffix=''
                :separator=separator
                :decimalSeparator=decimal_separator
                :decimals='0'
                :autoinit='true'
                @finished='counterFinished'
            /></h2>
            <p class="text-black textSmall">{{ $t('organizacion.cursos') }}</p>
          </div>
          <div class="col-12 col-lg p-3">
            <h2><AnimatedNumber
                ref='counter_participantes'
                :startAmount='0'
                :endAmount='13909'
                :duration='3'
                prefix=''
                suffix=''
                :separator=separator
                :decimalSeparator=decimal_separator
                :decimals='0'
                :autoinit='true'
                @finished='counterFinished'
            /></h2>
            <p class="text-black textSmall">{{ $t('organizacion.participantes') }}</p>
          </div>
          <div class="col-12 col-lg p-3">
            <h2>
              <AnimatedNumber
                  ref='counter_horas'
                  :startAmount='0'
                  :endAmount='86293'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  :decimalSeparator=decimal_separator
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
              /></h2>
            <p class="text-black textSmall">{{ $t('organizacion.horas') }}</p>
          </div>
          <div class="col-12 col-lg p-3">
            <h2><AnimatedNumber
                ref='counter_distancia'
                :startAmount='0'
                :endAmount='91'
                :duration='3'
                prefix=''
                suffix=''
                :separator=separator
                :decimalSeparator=decimal_separator
                :decimals='0'
                :autoinit='true'
                @finished='counterFinished'
            />%</h2>
            <p class="text-black textSmall">{{ $t('organizacion.distancia') }}</p>
          </div>
          <div class="col-12 col-lg p-3">
            <h2><AnimatedNumber
                ref='counter_eficacia'
                :startAmount='0'
                :endAmount='8.9'
                :duration='3'
                prefix=''
                suffix=''
                :separator=separator
                :decimalSeparator=decimal_separator
                :decimals='1'
                :autoinit='true'
                @finished='counterFinished'
            /></h2>
            <p class="text-black textSmall">{{ $t('organizacion.satisfacion') }}</p>
          </div>
        </div>
        <hr class="filigrana">
      </div>
    </section>


    <section class="p-0 p-lg-5 mx-0 mx-lg-5 my-0 pt-lg-0">
      <div class="container bg-blau p-3 m-0 mt-5 mt-lg-0 px-lg-5 py-lg-5">
        <h5 class="mb-4">{{ $t('literals.contribucion_a_los_ods') }}</h5>
        <div class="row justify-content-center">
            <div class="col-3 col-lg-1 p-0 m-2">
              <img :src="`${publicPath}img/${locale}ODS03.png`" data-aos="fade-left" data-aos-delay="100" data-aos-duration="1000" class="img-responsive">
            </div>
            <div class="col-3 col-lg-1 p-0 m-2">
              <img :src="`${publicPath}img/${locale}ODS04.png`" data-aos="fade-left" data-aos-delay="200" data-aos-duration="1000" class="img-responsive">
            </div>
            <div class="col-3 col-lg-1 p-0 m-2">
              <img :src="`${publicPath}img/${locale}ODS05.png`" data-aos="fade-left" data-aos-delay="300" data-aos-duration="1000" class="img-responsive">
            </div>
            <div class="col-3 col-lg-1 p-0 m-2">
              <img :src="`${publicPath}img/${locale}ODS08.png`" data-aos="fade-left" data-aos-delay="400" data-aos-duration="1000" class="img-responsive">
            </div>
            <div class="col-3 col-lg-1 p-0 m-2">
              <img :src="`${publicPath}img/${locale}ODS10.png`" data-aos="fade-left" data-aos-delay="500" data-aos-duration="1000" class="img-responsive">
            </div>
            <div class="col-3 col-lg-1 p-0 m-2">
              <img :src="`${publicPath}img/${locale}ODS16.png`" data-aos="fade-left" data-aos-delay="600" data-aos-duration="1000" class="img-responsive">
            </div>
        </div>
      </div>
    </section>


    <!-- NAVEGACIÓ PRE-FOOTER -->
    <hr>
    <div class="row p-0 g-0 mb-3">
      <div class="col-6 p-0 m-0 pb-3 text-start">
        <localized-link class="footerLink" to="/nuestra-actuacion-en-2021/tecnologia-al-servicio-de-las-personas"><img :src="`${publicPath}img/arrowLeft.png`" class="img-responsive arrowsFooter"> {{ $t("nav.tecnologia-al-servicio-de-las-personas") }}</localized-link>
      </div>
      <div class="col-6 p-0 m-0 pb-3 text-end textSmall">
        <localized-link class="footerLink" to="/sostenibilidad">{{ $t("nav.sostenibilidad") }} <img :src="`${publicPath}img/arrowRight.png`" class="img-responsive arrowsFooter"></localized-link>
      </div>
    </div>

  </div>
</template>

<script>
import AnimatedNumber from "vue3-autocounter";

export default {
  components: {
    AnimatedNumber,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      separator: '.',
      decimal_separator: ',',
      locale:this.$i18n.locale,
    }
  },
  mounted() {
    document.addEventListener('aos:in:start-counter-informe', this.startCounter);
    document.addEventListener('aos:in:start-counter-cuidado', this.startCounterCuidado);
    document.addEventListener('aos:in:start-counter-equipo', this.startCounterEquipo);
    document.addEventListener('aos:in:start-counter-pacientes', this.startCounterPacientes);
    document.addEventListener('aos:in:start-counter-inversiones', this.startCounterInversiones);
    document.addEventListener('aos:in:start-counter-nacionalidades', this.startCounterNacionalidades);
    document.addEventListener('aos:in:start-counter-edu', this.startCounterEdu);


    if(this.$i18n.locale=="en"){
      this.separator = ',';
      this.decimal_separator = '.';
    } else {
      this.separator = '.';
      this.decimal_separator = ',';
    }
  },
  methods: {
    startCounter() {
      if (this.$refs.counter_paginas != null) {
        this.$refs.counter_paginas.start();
      }

      if (this.$refs.counter_noticias != null) {
        this.$refs.counter_noticias.start();
      }
      if (this.$refs.counter_seguidores != null) {
        this.$refs.counter_seguidores.start();
      }
    },
    startCounterCuidado() {
      if (this.$refs.counter_comunicados != null) {
        this.$refs.counter_comunicados.start();
      }
      if (this.$refs.counter_publicadas != null) {
        this.$refs.counter_publicadas.start();
      }
      if (this.$refs.counter_unicas != null) {
        this.$refs.counter_unicas.start();
      }
      if (this.$refs.counter_suscriptoras != null) {
        this.$refs.counter_suscriptoras.start();
      }
    },
    startCounterEquipo() {

      if (this.$refs.counter_envios != null) {
        this.$refs.counter_envios.start();
      }
      if (this.$refs.counter_impactos != null) {
        this.$refs.counter_impactos.start();
      }
      if (this.$refs.counter_empresas != null) {
        this.$refs.counter_empresas.start();
      }
      if (this.$refs.counter_impactos_2 != null) {
        this.$refs.counter_impactos_2.start();
      }
    },
    startCounterPacientes() {

      if (this.$refs.counter_mujeres != null) {
        this.$refs.counter_mujeres.start();
      }
      if (this.$refs.counter_trabajadoras != null) {
        this.$refs.counter_trabajadoras.start();
      }
      if (this.$refs.counter_hombres != null) {
        this.$refs.counter_hombres.start();
      }
    },
    startCounterInversiones() {

      if (this.$refs.counter_anos != null) {
        this.$refs.counter_anos.start();
      }
      if (this.$refs.counter_antig != null) {
        this.$refs.counter_antig.start();
      }
      if (this.$refs.counter_superior != null) {
        this.$refs.counter_superior.start();
      }
    },
    startCounterNacionalidades() {

      if (this.$refs.counter_nacionalidades != null) {
        this.$refs.counter_nacionalidades.start();
      }
      if (this.$refs.counter_discapacidad != null) {
        this.$refs.counter_discapacidad.start();
      }
      if (this.$refs.counter_indefinidos != null) {
        this.$refs.counter_indefinidos.start();
      }
      if (this.$refs.counter_completo != null) {
        this.$refs.counter_completo.start();
      }
    },
    startCounterEdu() {

      if (this.$refs.counter_cursos != null) {
        this.$refs.counter_cursos.start();
      }
      if (this.$refs.counter_participantes != null) {
        this.$refs.counter_participantes.start();
      }
      if (this.$refs.counter_horas != null) {
        this.$refs.counter_horas.start();
      }
      if (this.$refs.counter_distancia != null) {
        this.$refs.counter_distancia.start();
      }
      if (this.$refs.counter_eficacia != null) {
        this.$refs.counter_eficacia.start();
      }
    }
  }
}
</script>
